import { render } from "./timer-count-down.vue?vue&type=template&id=635a18a6&scoped=true&ts=true"
import script from "./timer-count-down.vue?vue&type=script&lang=ts"
export * from "./timer-count-down.vue?vue&type=script&lang=ts"

import "./timer-count-down.vue?vue&type=style&index=0&id=635a18a6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635a18a6"]])

export default __exports__